import styles from './cta.module.css'
import React from 'react'
import logo from './logo.jpg'
import { Container, Message, Dropdown, Divider, Form, Image, Card, Button, Transition, Label } from 'semantic-ui-react'
import { countryOptions } from './country'
import FormData from 'form-data'
import 'isomorphic-fetch'
import { leadXML } from '../../utils/utils'

const LeadCapture = (name, email, phone, title, notify) => {
  notify();
  const options = {
     'method': "GET",
     'mode': 'no-cors',
     'headers': {
       'Access-Control-Allow-Origin': '*',
       'Access-Control-Allow-Methods': 'DELETE, HEAD, GET, OPTIONS, POST, PUT'
     }
  }
   fetch('https://crm.zoho.com/crm/private/xml/Leads/insertRecords' +
     `?newFormat=1&authtoken=1c14b7892ce0efb2bdba1bcbbfb6e832&scope=crmapi&xmlData=${leadXML(name, email, phone, title)}`, options)
   .then(function (response) {
     console.log(response);
   })
   .catch(function (error) {
     console.log(error);
   });
}
const Headline = ({title}) => (<p>Looking for <b>{title}</b> information?</p>);

class CallToAction extends React.Component {

  constructor(props) {
    super(props);
    this.state = { fullname: '', email: '', country: '', phone: '', title: this.props.title }
    this.state = { visible: false }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e, {name, value}) {
    this.setState({[name] : value})
  }

  handleSubmit = () => {
    const { fullname, email, country, phone } = this.state;
    const title = this.props.title;
    const notify = () => {
      this.setState({visible: true});
      setTimeout(() => {
        this.setState({fullname:''});
        this.setState({email:''});
        this.setState({phone:''});
        this.setState({country:''});
        this.setState({visible: false});
      },2000);
    }
    LeadCapture(fullname, email, phone, title, notify);
  }

  render() {
    const title = this.props.title;
    const { fullname, email, phone, country, visible }  = this.state;
    return <Card fluid>
      <Card.Content>
        <Label as='a' color='blue' ribbon>Know More About {title.toUpperCase()}?</Label>
        <Divider hidden />
        <Transition visible={visible} animation='scale' duration={500}>
          <Message info header='Thanks for Submission!' content="Our Education Expert Will Contact You Soon!" />
        </Transition>
        <Form size='tiny' unstackable={true} onSubmit={this.handleSubmit}>
            <Form.Input required placeholder='Full name (required)' name='fullname' onChange={this.handleChange} value={fullname}/>
            <Form.Input required placeholder='Email (required)' name='email' onChange={this.handleChange} value={email}/>
            <Form.Dropdown required placeholder='Select Country (required)' name='country' search selection options={countryOptions} onChange={this.handleChange} value={country}/>
            <Form.Input required placeholder='Phone Number (required)' name='phone' onChange={this.handleChange} value={phone}/>
            <Container className="field" textAlign="center" fluid>
            <Form.Button required basic color='blue'>Ask Our Expert Now !</Form.Button>
            </Container>
        </Form>
      </Card.Content>
    </Card>
  }
}


export default CallToAction



// WEBPACK FOOTER //
// ./src/components/CallToActionForm/index.js